import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { useLocalization } from '../localization/LocalizationContext';

interface HelpDialogProps {
  open: boolean;
  onClose: () => void;
}

export const HelpDialog: React.FC<HelpDialogProps> = ({ open, onClose }) => {
  const { t } = useLocalization();

  const sections = [
    t.help.basics,
    t.help.stitches,
    t.help.orientation,
    t.help.symmetry,
    t.help.guides,
    t.help.colors,
    t.help.tools,
    t.help.saving,
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{t.help.title}</DialogTitle>
      <DialogContent dividers>
        {sections.map((section, i) => (
          <React.Fragment key={i}>
            <Typography variant="h6" gutterBottom>{section.title}</Typography>
            <Typography paragraph>{section.content}</Typography>
          </React.Fragment>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t.help.close}</Button>
      </DialogActions>
    </Dialog>
  );
};
